// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ig-0";
export var fileList = "_ig-2";
export var removeFileButton = "_ig-1";